
import { Container } from "@mui/material";
import HeaderSession from "../../../utils/headerSession";
import RegisterAccess from "../../../utils/registerAccess";
import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import api from "../../../services/api";
import FichaImportadorSingular from "./fichaImportadorSingular";
import Loading from "../../../load/loading";
import ListaSolicitacoesDesalfandegamento from "../../departamentos/dmts/importacaoExportacao/listaSolicitacoesDesalfandegamento";


export default function ImportadorSigular() {
    const { id } = useParams()
    // const user = useSelector(state => state.account.user);
    const [importador, setImportador] = useState("");
    const navigate = useNavigate()

    useEffect(() => {
        api.get(`/estabelecimento/${id}`)
            .then(response => {
                // console.log(response)
                if (response.data.estabelecimento.status !== "Não Licenciado") {
                    navigate(-1)
                }
                setImportador(response.data.estabelecimento);
            }).catch(err => '')
    }, [id])


    return (
        <Container style={{ marginBottom: 10 }}>

            <RegisterAccess page={'importador nao licenciado'} />
            <HeaderSession title={'IMPORTADOR NÃO LICENCIADO'} />
            {/* {load ? <Loading /> : <InformacaoAdmin admin={admin} />} */}
            {importador ?
                <>
                    <FichaImportadorSingular importador={importador} local={'perfilAdmin'} />
                    <ListaSolicitacoesDesalfandegamento importadorId={importador._id} />
                </>
                : <Loading />}

        </Container>
    )
}